import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import { Toast } from 'vant';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'default-passive-events'
// import TIM from '@tencentcloud/chat';
// import TIMUploadPlugin from 'tim-upload-plugin';
import plugins from './plugins' // plugins

import imclient from './utils/imclient';

import { audioPlayer } from './utils/audio';

Vue.prototype.$audio = audioPlayer;

//公共方法 手机端跳转

imclient.install(Vue, { store })

// let options = {
//   SDKAppID: 1600069412 
// };
// // 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
// let tim = TIM.create(options); // SDK 实例通常用 chat 表示
// tim.setLogLevel(1); // 普通级别，日志量较多，接入时建议使用
// tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin });
// Vue.prototype.TIM = TIM
// Vue.prototype.tim = tim
let onTotalUnreadMessageCountUpdated = function (event) {
  store.commit('SetXiaonum', event.data)
  if (event.data != 0 && !isMobile()) {
    let opt = {
      dir: "auto", // 文字方向
      body: `您有${store.state.xiaonum}条新消息`, // 通知主体
      requireInteraction: false, // 不自动关闭通知
      icon: "https://gcaibang-bucket.oss-cn-chengdu.aliyuncs.com/uploads/20250104/016e54841b43680335bcad9dd45d4847.png"
    };
    notifyMe('广材帮消息通知', opt);
  }
  if(event.data != 0)
  {
    audioPlayer.playTick()
  }
  imclient.getConversationList(["C2Cxj1"]).then(res => {
    let num = 0
    if(res.data.conversationList.length!=0){
      num = res.data.conversationList[0].unreadCount
    }
    store.commit('SetKfxiaonum', num)
  })
};
// tim.on(TIM.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED, onTotalUnreadMessageCountUpdated);

imclient.on(imclient.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED, onTotalUnreadMessageCountUpdated);


function gopage(id) {
  let promise = imclient.getUserProfile({
      userIDList: ['xj' + id] // 请注意：即使只拉取一个用户的资料，也需要用数组类型，例如：userIDList: ['user1']
  })
  promise.then(function (imResponse) {
      if(imResponse.data.length != 0)
      {
        let obj = {
            userProfile: imResponse.data[0]
        }
        localStorage.setItem('hyinfo',JSON.stringify(obj))
        router.push({ path: "/indexdetail", query: obj }).catch(() => { });
      }
  }).catch(function (imError) {
      console.warn('getUserProfile error:', imError);
  });
}

Vue.prototype.$dataConver = {gopage};


function isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}


function notifyMe(title, opt) {
  // 先检查浏览器是否支持
  if (!window.Notification) {
    console.log('浏览器不支持通知');
  } else {
    // 检查用户曾经是否同意接受通知
    if (Notification.permission === 'granted') {
      const instanceNotification = new Notification(title, opt); // 显示通知
      store.commit('Setisplay', true)
      instanceNotification.onclick = e => {
        store.commit('Setisplay', false)
        window.focus();
        instanceNotification.close()
      }
    } else if (Notification.permission === 'default') {
      // 用户还未选择，可以询问用户是否同意发送通知
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          const instanceNotification = new Notification(title, opt); // 显示通知
          store.commit('Setisplay', true)
          instanceNotification.onclick = e => {
            store.commit('Setisplay', false)
            window.focus();
            instanceNotification.close()
          }
        } else if (permission === 'default') {
          console.warn('用户关闭授权 未刷新页面之前 可以再次请求授权');
        } else {
          // denied
          console.log('用户拒绝授权 不能显示通知');
        }
      });
    } else {
      // denied 用户拒绝
      console.log('用户曾经拒绝显示通知');
    }
  }
}
// 分页组件
import Pagination from "@/components/Pagination";
// 全局组件挂载
Vue.component('Pagination', Pagination)

import { filters } from './utils/filters'
// 定义全局自定义过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(Toast);
Vue.use(plugins)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
